function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b4b4b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Lager_2",
  "data-name": "Lager 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "_\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M27.07,14.71H1.79A1.79,1.79,0,0,1,0,12.92V1.79A1.79,1.79,0,0,1,1.79,0H27.07a1.79,1.79,0,0,1,1.79,1.79V12.92A1.79,1.79,0,0,1,27.07,14.71ZM3.58,11.13h21.7V3.58H3.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M77.2,136.73H17.08a13.81,13.81,0,0,1-13.8-13.8v-110a1.79,1.79,0,0,1,1.79-1.79H23.79a1.79,1.79,0,0,1,1.79,1.79V29.05a2,2,0,0,0,3.7.91L33,22.89h0a1.79,1.79,0,0,1,3.17,1.67h0a9.29,9.29,0,0,0,4.29,12.71L77.6,54.7a6.89,6.89,0,0,0,9.81-6.24,1.79,1.79,0,1,1,3.58,0v74.47A13.81,13.81,0,0,1,77.2,136.73ZM6.86,14.71V122.93a10.23,10.23,0,0,0,10.22,10.22H77.2a10.22,10.22,0,0,0,10.21-10.22V56.35a11,11,0,0,1-1.27.95,10.42,10.42,0,0,1-10.06.64L38.93,40.51A12.72,12.72,0,0,1,32.2,33c-.07-.2-.14-.41-.19-.61a5.55,5.55,0,0,1-10-3.3V14.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M89.2,50.25a1.79,1.79,0,0,1-1.79-1.79V35.58a14.53,14.53,0,0,0-8.33-13.11l-25.52-12a9.27,9.27,0,0,0-12.17,4.09l-5.22,10A1.79,1.79,0,1,1,33,22.88l5.22-9.95A12.85,12.85,0,0,1,55.08,7.26l25.52,12A18.12,18.12,0,0,1,91,35.58V48.46A1.79,1.79,0,0,1,89.2,50.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M71.85,123.83H22.46a6.23,6.23,0,0,1-6.25-6.34,277.84,277.84,0,0,1,8.48-63.8A8.06,8.06,0,0,1,35.92,48.4l34.15,16h0a14,14,0,0,1,8,12.64v40.53A6.26,6.26,0,0,1,71.85,123.83ZM32.49,51.22a4.48,4.48,0,0,0-4.33,3.35,274.16,274.16,0,0,0-8.37,63,2.68,2.68,0,0,0,2.67,2.7H71.85a2.66,2.66,0,0,0,2.66-2.66V77.06a10.41,10.41,0,0,0-6-9.4l-34.14-16A4.43,4.43,0,0,0,32.49,51.22Z"
})));

function SvgOil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90.99 136.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOil);
export default __webpack_public_path__ + "static/media/oil.47bf0539.svg";
export { ForwardRef as ReactComponent };